import { render, staticRenderFns } from "./ProductPages.vue?vue&type=template&id=1939d8bb&scoped=true&"
import script from "./ProductPages.vue?vue&type=script&lang=js&"
export * from "./ProductPages.vue?vue&type=script&lang=js&"
import style0 from "./ProductPages.vue?vue&type=style&index=0&id=1939d8bb&prod&lang=scss&"
import style1 from "./ProductPages.vue?vue&type=style&index=1&id=1939d8bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1939d8bb",
  null
  
)

export default component.exports